import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Send } from "lucide-react";

export default function SubmitProjectDialog({ open, onClose }) {
  const { user, openAuth } = useAuth();
  const [form, setForm] = useState({ title: "", contact: "", summary: "", detail: "" });
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!user) {
      onClose();
      openAuth();
      return;
    }
    setBusy(true);
    try {
      await api.post("/submissions", form);
      toast.success("投稿成功！平台审核评估录用后，奖励（最高 ¥188,888）自动到账");
      setForm({ title: "", contact: "", summary: "", detail: "" });
      onClose();
    } catch (e2) {
      toast.error(apiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="bg-[#0F0F14] border border-[#D4AF37]/25 text-[#F8F9FA] sm:max-w-lg"
        data-testid="submit-dialog"
      >
        <DialogTitle className="font-serif-sc text-xl tracking-widest text-center">项目投稿 · 平台审核评估</DialogTitle>
        <p className="text-xs text-center text-[#D4AF37] tracking-widest border border-[#D4AF37]/20 bg-[#D4AF37]/5 px-4 py-2.5 mt-2">
          投稿一经录用，奖励最高 ¥188,888 自动计入可提现余额
        </p>
        <form onSubmit={submit} className="mt-4 flex flex-col gap-3">
          <input
            data-testid="submit-title-input"
            value={form.title}
            onChange={set("title")}
            placeholder="项目名称"
            maxLength={50}
            className="input-gold w-full px-4 py-2.5 text-sm"
            required
          />
          <input
            data-testid="submit-contact-input"
            value={form.contact}
            onChange={set("contact")}
            placeholder="联系方式（微信号 / 手机号）"
            maxLength={50}
            className="input-gold w-full px-4 py-2.5 text-sm font-mono-num"
            required
          />
          <textarea
            data-testid="submit-summary-input"
            value={form.summary}
            onChange={set("summary")}
            placeholder="项目简介（一句话说清做什么、怎么赚）"
            rows={2}
            maxLength={500}
            className="input-gold w-full px-4 py-2.5 text-sm resize-none"
            required
          />
          <textarea
            data-testid="submit-detail-input"
            value={form.detail}
            onChange={set("detail")}
            placeholder="项目详情与收益说明：操作路径、投入成本、实测收益、所需资源等（越详细越容易通过评估）"
            rows={5}
            maxLength={5000}
            className="input-gold w-full px-4 py-2.5 text-sm"
          />
          <button data-testid="submit-form-submit-btn" type="submit" disabled={busy} className="btn-gold py-2.5 text-sm inline-flex items-center justify-center gap-2">
            <Send className="w-4 h-4" /> {busy ? "提交中..." : "提交投稿"}
          </button>
        </form>
        <p className="text-[10px] text-gray-600 text-center mt-2">平台专业团队审核评估 · 拒绝不收取任何费用 · 结果将以站内通知告知</p>
      </DialogContent>
    </Dialog>
  );
}
